import React from "react";
import { Box, Tabs, TabList, TabPanels, TabPanel, Tab, Icon } from "@chakra-ui/react";
import BackgroundImage from "../../../assets/img/longarrow.jpg";
import KilometerManagement from "../PackagePlanManagement";
import KilometerRatesManagement from "../KilometerRatesManagement";
import { Package, DollarSign } from "lucide-react";

// Custom Tab Component
const CustomTab = ({ icon, label }) => (
  <Tab
    fontSize="sm"
    color="gray.500"
    _selected={{
      color: "white",
      bg: "transparent",
      backgroundImage: `url(${BackgroundImage})`,
      backgroundSize: "cover",
      backgroundPosition: "center",
    }}
  >
    <Icon as={icon} mr={2} />
    {label}
  </Tab>
);

// Main Tabs Component
const PackageAndRatesTabs = () => {
  return (
    <Box w="100%" p={4} mt="70px" ml="9px">
      <Tabs variant="enclosed">
        <TabList>
          <CustomTab icon={Package} label="Package Plans" />
          <CustomTab icon={DollarSign} label="Kilometer Rates" />
        </TabList>

        <TabPanels>
          {/* Package Plans Tab */}
          <TabPanel>
            <KilometerManagement />
          </TabPanel>

          {/* Kilometer Rates Tab */}
          <TabPanel>
            <KilometerRatesManagement />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Box>
  );
};

export default PackageAndRatesTabs;
